// extracted by mini-css-extract-plugin
export default {"questionsWrapper":"styles_questionsWrapper__tMtgL","disable":"styles_disable__GhCB2"};